// import {observable, action} from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import { RepositoryEntries } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { NextIcon } from '../../../../ui/common/icons';
import { Table, TableCell, TableRow } from '../../../../ui/widgets/table/table';
import { formatInstant } from '../../../../util/formatters';
import { TabPanel } from '../tab-panel/tab-panel';
const styles = require('./repository-file-picker.css');
const fonts = require('../../../../ui/common/fonts.css');

/** UI for browsing and selecting files from a repository (essentially an S3 bucket). */
/// We're using 'file' throughout here, but it's pretty obvs this is about logo and image files
/// - no checking or parsing done before dumping URLs into <img> tags

// /** Essential file info */
// export interface RepositoryFileData {
//   currentFile: boolean;
//   url: string;
//   /// Possibly @computed
//   fileName: string;
//   fileSize: string;
//   lastUpdated: string;
// }

/** RepositoryFilePicker props definitions */
export interface RepositoryFilePickerProps {
  /// Fetched from S3 bucket
  data: RepositoryEntries;
  /// hoisting file selections
  currentFile?: string;
  onChange(l: string): void;
}

@observer
export class RepositoryFilePicker extends React.Component<RepositoryFilePickerProps> {
  render() {
    const { /*repositoryName*,*/ path, entries } = this.props.data;
    return (
      /// ----- [ TODO S3 bucket name or subfolder name (dedicated to client) ] -----
      <TabPanel id="repo-list-1" tabId="1">
        <p className={fonts.caption}>Contents of repository:{path}</p>
        <Table
          alignRightColumn2
          alignCenterColumn3
          column2VisibleAfter="sm"
          column3VisibleAfter="sm"
          className={styles.noBorder}
        >
          <TableRow header>
            <TableCell>NAME</TableCell>
            <TableCell>SIZE</TableCell>
            <TableCell>LAST ACCESSED</TableCell>
            <TableCell />
          </TableRow>
          {entries.map(entry => {
            return (
              <TableRow
                key={entry.value.path}
                onClick={() => this.props.onChange(entry.value.path)}
                className={this.props.currentFile === entry.value.path ? styles.currentFile : ''}
              >
                <TableCell>
                  <div>{entry.kind === 'file' && <img /*width="50"*/ height="50" src={entry.value.publicUrl} />}</div>
                  <div className={fonts.caption}>{entry.value.path}</div>
                </TableCell>
                <TableCell>
                  <span className={fonts.caption}>{entry.kind === 'file' ? entry.value.size : '(Folder)'}</span>
                </TableCell>
                <TableCell>
                  <span className={fonts.caption}>{formatInstant(entry.value.lastModified, 'DD/MM/YYYY HH:mm')}</span>
                </TableCell>
                <TableCell>
                  <NextIcon size="xsmall" />
                </TableCell>
              </TableRow>
            );
          })}
        </Table>
      </TabPanel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/repository-file-picker/repository-file-picker.tsx